import { Type, Tag, QrCode, Image, Square } from "lucide-react";

export const A4_RATIO = 841.89 / 595.27;

export const uid = () => Math.random().toString(36).substr(2, 9);

export const DYNAMIC_FIELDS = [
  { id: "nombre_cliente", label: "Nombre cliente" },
  { id: "matricula", label: "Matricula" },
  { id: "telefono", label: "Telefono" },
  { id: "email", label: "Email" },
  { id: "fecha_emision", label: "Fecha emision" },
  { id: "fecha_caducidad", label: "Fecha caducidad" },
  { id: "centro", label: "Centro" },
  { id: "asesor", label: "Asesor" },
  { id: "codigo_bono", label: "Codigo bono" },
  { id: "observaciones", label: "Observaciones" },
  { id: "valor_estimado", label: "Valor estimado" },
  { id: "tipo_bono", label: "Tipo de bono" },
];

export const SAMPLE_DATA = {
  nombre_cliente: "Maria Garcia Lopez",
  matricula: "1234 ABC",
  telefono: "600 123 456",
  email: "maria@ejemplo.com",
  fecha_emision: "2026-01-15",
  fecha_caducidad: "2026-03-15",
  centro: "Ascauto Madrid",
  asesor: "Carlos Ruiz",
  codigo_bono: "ASC-ATC-2026-000042",
  observaciones: "Lavado completo exterior e interior",
  valor_estimado: "50 EUR",
  tipo_bono: "BONO DE LAVADO GRATUITO",
};

export const ELEMENT_DEFAULTS = {
  text: { type: "text", text: "Texto", x: 20, y: 50, width: 30, height: 4, fontSize: 14, fontWeight: "normal", color: "#0f172a", textAlign: "left", opacity: 1 },
  dynamic_field: { type: "dynamic_field", field: "nombre_cliente", label: "CLIENTE", x: 20, y: 50, width: 40, height: 7, fontSize: 14, fontWeight: "bold", color: "#0f172a", labelColor: "#94a3b8", textAlign: "left", opacity: 1 },
  qr: { type: "qr", x: 78, y: 78, width: 14, height: 10, opacity: 1 },
  shape: { type: "shape", shape: "rect", x: 20, y: 50, width: 30, height: 5, color: "#e2e8f0", borderRadius: 0, opacity: 1 },
  image: { type: "image", source: "logo", x: 20, y: 50, width: 14, height: 5, opacity: 1 },
};

export function elLabel(el) {
  if (el.type === "text") return (el.text || "Texto").substring(0, 16);
  if (el.type === "dynamic_field") return `{${el.field}}`;
  if (el.type === "qr") return "Codigo QR";
  if (el.type === "image") return el.source === "logo" ? "Logo" : "Imagen";
  if (el.type === "shape") return el.shape === "line" ? "Linea" : "Bloque";
  return el.type;
}

export function elIcon(el) {
  if (el.type === "text") return <Type className="w-3 h-3" />;
  if (el.type === "dynamic_field") return <Tag className="w-3 h-3 text-blue-500" />;
  if (el.type === "qr") return <QrCode className="w-3 h-3" />;
  if (el.type === "image") return <Image className="w-3 h-3 text-emerald-500" />;
  if (el.type === "shape") return <Square className="w-3 h-3 text-slate-400" />;
  return <Square className="w-3 h-3" />;
}
